import { useState, useEffect } from 'react';
import { CircularProgress, Grid, Button, Typography, Stack } from '@material-ui/core';
import { useParams } from 'react-router';
import Page from '../components/Page';
import { userAtom } from 'src/atoms/user';
import { useRecoilValue } from 'recoil';
import { useQuery } from 'react-query';
import { useTheme } from '@material-ui/core/styles';
import { boxStyling, loaderStyle } from 'src/utils/styles';
import RequestHeader from 'src/components/admin/Request/RequestHeader';
import { queryClient } from 'src';
import { checkRequest, resolveRequest } from 'src/services/finance.service';
import ConfirmationDialogue from 'src/components/ConfirmationDialogue';
import EmployeeRequestPage from './EmployeeRequestPage';

const FinanceRequestPage = () => {
  const { id } = useParams();
  const user = useRecoilValue(userAtom);
  const {
    data,
    isLoading: loading,
    isError,
    error
  } = useQuery('finance_request', async () => await checkRequest(id));

  const theme = useTheme();

  const [amountUSD, setAmountUSD] = useState();
  const [confirmationState, setConfirmationState] = useState({
    open: false,
    state: ''
  });

  useEffect(() => {
    if (data) {
      setAmountUSD(data.request.deserved_amount);
    }
  }, [data]);

  useEffect(() => {
    return () => {
      queryClient.removeQueries('finance_request');
    };
  }, []);

  if (loading) {
    return <CircularProgress style={loaderStyle} />;
  }
  if (isError) {
    return <Typography variant="h3">Somthing went wrong: {error.message}</Typography>;
  }
  if (
    data?.request?.employee?.id === user?.id &&
    data?.request?.status !== 'PENDING_FINANCE_REVIEW'
  ) {
    return <EmployeeRequestPage />;
  }
  return (
    <Page title={'Finance Requests | Incorta Care'}>
      <ConfirmationDialogue
        open={confirmationState.open}
        setOpen={(state) => setConfirmationState((prev) => ({ ...prev, open: state }))}
        queryId={'finance_request'}
        redirectUrl={'/dashboard/all-requests'}
        onConfirm={() => resolveRequest({ id: data.request.id })}
        loadingMessage={'Please wait while we process your request'}
        successMessage={`Request has been ${
          confirmationState.state === 'approve' ? 'approved' : 'disapproved'
        } successfully`}
        confirmationMessage={`Are you sure you want to proceed with this request? Make sure you have checked all the details before proceeding.`}
      />
      <Grid container direction="column" spacing={0} style={{ padding: '12px' }}>
        <RequestHeader data={data} usd={Number(amountUSD)} showBills={false} />

        <Grid container spacing={4} marginTop={2}>
          <Grid item xs={12} container>
            <Grid
              xs={12}
              container="true"
              style={{
                ...boxStyling,
                marginTop: 0,
                width: '100%',
                height: '100%',
                padding: '15px 20px'
              }}
            >
              <Grid
                item
                xs={12}
                marginBottom={2}
                container
                justifyContent={'space-between'}
                alignItems={'center'}
              >
                <Typography variant="h4">{'Request Amount'}</Typography>
              </Grid>

              {[{ value: data.request.deserved_amount_egp, currency: 'EGP' }].map((amount, i) => (
                <Grid
                  key={i}
                  item
                  xs={12}
                  md={6}
                  padding={2}
                  justifyContent={'center'}
                  alignItems={'center'}
                  container
                >
                  <Stack direction={'row'} alignItems={'flex-end'} gap={0.5}>
                    <Typography variant="h1" style={{ color: theme.palette.grey[800] }}>
                      {Number(amount.value).toFixed(2)}
                    </Typography>
                    <Typography
                      variant="h4"
                      style={{ paddingBottom: theme.spacing(1), color: theme.palette.grey[500] }}
                    >
                      {amount.currency}
                    </Typography>
                  </Stack>
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid direction="column" container key={'Doctor Comments'} item xs={12} md={6}>
            <div style={{ ...boxStyling, marginTop: 0, width: '100%', height: '100%' }}>
              <Typography variant="h4">{'Doctor Comments'}</Typography>
              <Typography variant="body1" paddingLeft={1}>
                {data.request['dr_comments'] || 'NA'}
              </Typography>
            </div>
          </Grid>

          <Grid item xs={12} md={6} container direction={'column'}>
            <div style={{ ...boxStyling, marginTop: 0, width: '100%', height: '100%' }}>
              <Typography variant="h4">Admin Comments</Typography>
              <Typography variant="body1" paddingLeft={1}>
                {data.request['admin_comments'] || 'NA'}
              </Typography>
            </div>
          </Grid>
        </Grid>

        <Stack container gap={2} direction={'row'}></Stack>

        <Stack
          direction={'row'}
          justifyContent={'flex-end'}
          style={{
            display: data.request.status !== 'PENDING_FINANCE_REVIEW' ? 'none' : 'flex'
          }}
        >
          {/*<Button*/}
          {/*  variant="contained"*/}
          {/*  color="incorta"*/}
          {/*  style={{ marginTop: '20px' }}*/}
          {/*  onClick={() => setConfirmationState({ open: true, state: 'approve' })}*/}
          {/*  size="large"*/}
          {/*  disabled={data.request.status !== 'PENDING_FINANCE_REVIEW'}*/}
          {/*>*/}
          {/*  Proceed*/}
          {/*</Button>*/}
        </Stack>
      </Grid>
    </Page>
  );
};

export default FinanceRequestPage;
